
<div class="race-container">
  <h2>Prijavnica</h2>
  <p>Prosimo izpolnite podatke.</p>
  
  <form [formGroup]="raceForm" (ngSubmit)="onSubmit()">
    <div class="form-row">
      <div class="form-column">
        <label for="name">Ime in Priimek:</label>
        <input id="name" type="text" formControlName="name" required />
        
        <label for="email">Email:</label>
        <input id="email" type="email" formControlName="email" required />
        
        <label for="yearOfBirth">Leto rojstva:</label>
        <input id="yearOfBirth" type="number" formControlName="yearOfBirth" required />
        
        <label for="sex">Spol:</label>
        <select id="sex" formControlName="sex">
          <option value="Male">M</option>
          <option value="Female">Ž</option>
        </select>
      </div>
      
      <div class="form-column">
        <label for="phone">Telefon:</label>
        <input id="phone" type="text" formControlName="phone" required />

        <label for="club">Klub:</label>
        <input id="club" type="text" formControlName="club" />
        
        <label for="numOfLaps">Željeno število kilometrov:</label>
        <input id="numOfLaps" type="number" formControlName="numOfKm" min="2" max="50" placeholder="Najmanj 2 km in največ 50 km." required />

        <label for="timeOfArrival">Čas začetka:</label>
        <select id="timeOfArrival" formControlName="timeOfArrival" required>
          <option *ngFor="let hour of [9,10,11,12,13,14,15]" [value]="hour + ':00'">{{ hour }}:00</option>
        </select>
      </div>
    </div>
    <button type="submit" [disabled]="!raceForm.valid">Pošlji prijavo</button>
  </form>
</div>
  
<!-- Table of Racers -->
<div *ngIf="isOrgAdmin" class="container table mt-5">
  <h3>Seznam tekmovalcev</h3>
  <p>Število prijavljenih: {{ racers.length }}</p>

  <!-- Scrollable container -->
  <div style="overflow-x: auto; width: 100%;">
    <table *ngIf="racers.length > 0" border="1" cellpadding="10" cellspacing="0" style="width: 100%; margin-top: 20px; white-space: nowrap;">
      <thead>
        <tr>
          <th>Ime</th>
          <th>Leto rojstva</th>
          <th>Spol</th>
          <th>Telefon</th>
          <th>Email</th>
          <th>Klub</th>
          <th>Število kilometrov</th>
          <th>Čas prihoda</th>
          <th>Čas prijave</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let racer of racers">
          <td>{{ racer.name }}</td>
          <td>{{ racer.yearOfBirth }}</td>
          <td>{{ racer.sex }}</td>
          <td>{{ racer.phone }}</td>
          <td>{{ racer.email }}</td>
          <td>{{ racer.club }}</td>
          <td>{{ racer.numOfKm }}</td>
          <td>{{ racer.timeOfArrival }}</td>
          <td>{{ racer.enrolledAt }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <p *ngIf="racers.length === 0">Ni še registriranih tekmovalcev.</p>
  <!-- Add the download button -->
  <button (click)="downloadCSV()">Naloži CSV</button>
</div>

